import type { MouseEvent } from "react";

import type { ButtonProps } from "@aviary/components/Button/Button.types";
import { useDropdownContext } from "@aviary/components/Dropdown/DropdownContext";

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const useDropdownButtonProps = (): Partial<ButtonProps> => {
  const {
    onTriggerClicked,
    setMouseOverTrigger,
    setTriggerFocused,
    isDisabled,
    isFullWidth,
    setTriggerElement,
  } = useDropdownContext();

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    onTriggerClicked?.();
    if (e) setTriggerElement?.(e.currentTarget);
  };

  const onMouseEnter = (e: MouseEvent<HTMLButtonElement>) => {
    setMouseOverTrigger(true);
    if (e) setTriggerElement?.(e.currentTarget);
  };

  const onMouseLeave = () => {
    setMouseOverTrigger(false);
  };

  const onFocus = () => {
    setTriggerFocused(true);
  };

  const onBlur = () => {
    setTriggerFocused(false);
  };

  return {
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    disabled: isDisabled,
    isFullWidth,
  };
};

export { useDropdownButtonProps };
